"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KudosV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "RegisteredKudos",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
        ],
        name: "TransferBatch",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "TransferSingle",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "value",
                type: "string",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "URI",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "CLAIM_TYPE_HASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CONTRACT_NAME",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CONTRACT_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "KUDOS_TYPE_HASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "tokenIds",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "prevCommunityDiscordIds",
                type: "string[]",
            },
            {
                internalType: "string[]",
                name: "newCommunityUniqIds",
                type: "string[]",
            },
        ],
        name: "backdoorConversionOfCommunityData",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "accounts",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
        ],
        name: "balanceOfBatch",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "claimee",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "claimBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "communityRegistryAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "exists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getAllowlistedContributors",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getKudosMetadata",
        outputs: [
            {
                components: [
                    {
                        internalType: "string",
                        name: "headline",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "startDateTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endDateTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "string[]",
                        name: "links",
                        type: "string[]",
                    },
                    {
                        internalType: "string",
                        name: "DEPRECATED_communityDiscordId",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "DEPRECATED_communityName",
                        type: "string",
                    },
                    {
                        internalType: "address",
                        name: "creator",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "registeredTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "string",
                        name: "communityUniqId",
                        type: "string",
                    },
                ],
                internalType: "struct KudosV2.KudosContainer",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_latestUnusedTokenId",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestUnusedTokenId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "string",
                        name: "headline",
                        type: "string",
                    },
                    {
                        internalType: "string",
                        name: "description",
                        type: "string",
                    },
                    {
                        internalType: "uint256",
                        name: "startDateTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "endDateTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "string[]",
                        name: "links",
                        type: "string[]",
                    },
                    {
                        internalType: "string",
                        name: "communityUniqId",
                        type: "string",
                    },
                    {
                        internalType: "address[]",
                        name: "contributors",
                        type: "address[]",
                    },
                ],
                internalType: "struct KudosV2.KudosInputContainer",
                name: "metadata",
                type: "tuple",
            },
            {
                internalType: "bool",
                name: "mintForCreator",
                type: "bool",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "registerBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeBatchTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_communityRegistryAddress",
                type: "address",
            },
        ],
        name: "setCommunityRegistryAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_latestUnusedTokenId",
                type: "uint256",
            },
        ],
        name: "setLatestUnusedTokenId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newuri",
                type: "string",
            },
        ],
        name: "setURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "tokenIdToContributors",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "tokenIdToKudosContainer",
        outputs: [
            {
                internalType: "string",
                name: "headline",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "startDateTimestamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endDateTimestamp",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "DEPRECATED_communityDiscordId",
                type: "string",
            },
            {
                internalType: "string",
                name: "DEPRECATED_communityName",
                type: "string",
            },
            {
                internalType: "address",
                name: "creator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "registeredTimestamp",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "communityUniqId",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "uri",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class KudosV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.KudosV2__factory = KudosV2__factory;
KudosV2__factory.bytecode = _bytecode;
KudosV2__factory.abi = _abi;
